'use strict';

/* ─────────────────────────────────────────────────────────────────
   Represent CLO — Social Proof Slider
   CSS scroll-snap slider with arrows + dot indicators.
   iOS Safari safe: no transforms, no rAF loops, scroll-behavior:auto.
───────────────────────────────────────────────────────────────── */

(function () {
  function init() {
    document.querySelectorAll('[data-track]').forEach(function (track) {
      var sectionEl = track.closest('[id^="SocialProof-"]');
      if (!sectionEl) return;

      var sectionId  = sectionEl.id.replace('SocialProof-', '');
      var slides     = Array.from(track.querySelectorAll('[data-slide]'));
      var dotsWrap   = document.querySelector('[data-dots="' + sectionId + '"]');
      var dots       = dotsWrap ? Array.from(dotsWrap.querySelectorAll('[data-dot]')) : [];
      var btnPrev    = document.querySelector('[data-sp-prev="' + sectionId + '"]');
      var btnNext    = document.querySelector('[data-sp-next="' + sectionId + '"]');
      var current    = 0;

      if (!slides.length) return;

      /* ── Scroll to slide ─────────────────────────────────────── */
      function goTo(index) {
        current = Math.max(0, Math.min(index, slides.length - 1));
        var slide = slides[current];
        if (!slide) return;
        track.scrollLeft = slide.offsetLeft - track.offsetLeft;
        activateDot(current);
      }

      /* ── Dot state ───────────────────────────────────────────── */
      function activateDot(i) {
        dots.forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === i);
          d.setAttribute('aria-selected', idx === i ? 'true' : 'false');
        });
      }

      /* ── Dot clicks ──────────────────────────────────────────── */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.dot, 10));
        }, { passive: true });
      });

      /* ── Arrow clicks ────────────────────────────────────────── */
      if (btnPrev) {
        btnPrev.addEventListener('click', function () {
          goTo(current - 1);
        }, { passive: true });
      }

      if (btnNext) {
        btnNext.addEventListener('click', function () {
          goTo(current + 1);
        }, { passive: true });
      }

      /* ── IntersectionObserver → sync dot on swipe ────────────── */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var i = slides.indexOf(entry.target);
          if (i > -1) {
            current = i;
            activateDot(i);
          }
        });
      }, { root: track, threshold: 0.5 });

      slides.forEach(function (slide) { io.observe(slide); });

      /* ── Autoplay every 3 seconds ────────────────────────────── */
      var timer = null;

      function startAutoplay() {
        timer = setInterval(function () {
          var next = current + 1 < slides.length ? current + 1 : 0;
          goTo(next);
        }, 3000);
      }

      function stopAutoplay() {
        clearInterval(timer);
      }

      /* Pause on touch/arrow interaction, resume after 6 s */
      track.addEventListener('touchstart', function () {
        stopAutoplay();
        clearTimeout(track._resumeTimer);
        track._resumeTimer = setTimeout(startAutoplay, 6000);
      }, { passive: true });

      if (btnPrev) btnPrev.addEventListener('click', function () { stopAutoplay(); clearTimeout(track._resumeTimer); track._resumeTimer = setTimeout(startAutoplay, 6000); }, { passive: true });
      if (btnNext) btnNext.addEventListener('click', function () { stopAutoplay(); clearTimeout(track._resumeTimer); track._resumeTimer = setTimeout(startAutoplay, 6000); }, { passive: true });

      startAutoplay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
